import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { isNullOrUndefined } from 'util';
// models
import { Bodega } from '../../model/bodega';
import { Articulo } from '../../model/articulo';
import { Excepcion } from '../../model/excepcion';
import { Consorcio } from '../../model/consorcio';
import { Sucursal } from '../../model/sucursal';
import { Inventario } from '../../model/inventario';
import { Socio } from '../../model/socio';
import { Imagen } from '../../model/imagen';
import { DocumentoSalida } from '../../model/documento-salida';
import { DocumentoDetalleSalida } from '../../model/documento-detalle-salida';
import { Zona } from '../../model/zona';

// services

import { SucursalService } from '../../services/sucursal.service';
import { DocumentoSalidaService } from '../../services/documento-salida.service';
import { UtilitiesService } from '../../services/utilities.service';
import { SocioService } from '../../services/socio.service';
import { ArticuloService } from '../../services/articulo.service';
import { SubirImagenesService } from '../../services/subir-imagenes.service';
import { DocumentoDetalleSalidaService } from '../../services/documento-detalle-salida.service';
import { BodegaService } from '../../services/bodega.service';
import { ZonaService } from '../../services/zona.service';

// components

import { ArticuloBuscarComponent } from '../../components/articulo-buscar/articulo-buscar.component';
import { DocumentoGaleriaComponent } from '../../components/documento-galeria/documento-galeria.component';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-documento-salida-mantenimiento',
  templateUrl: './documento-salida-mantenimiento.component.html',
  styleUrls: ['./documento-salida-mantenimiento.component.css']
})
export class DocumentoSalidaMantenimientoComponent implements OnInit {
  @ViewChild(ArticuloBuscarComponent) _articuloBuscar: ArticuloBuscarComponent;
  @ViewChild(DocumentoGaleriaComponent) _galeria: DocumentoGaleriaComponent;


  @Output() onReturn = new EventEmitter();


  public consorcio: Consorcio = new Consorcio();
  public sucursal: Sucursal = new Sucursal();
  public cabecera: DocumentoSalida = new DocumentoSalida();
  public socios: Socio[];
  public bodegas: Bodega[];
  public filtro_exc: string;
  public socio: Socio;
  public bodega: Bodega;
  public articulo: Articulo;
  public inventario: Inventario;

  public zona: Zona;
  public zonas: Zona[];

  public detalle: DocumentoDetalleSalida;
  public detalles: DocumentoDetalleSalida[];

  public excepcionesDocumento: Excepcion[];

  public agregando: boolean;

  public cargandoImagen: boolean;

  public _external_codigoDocumento: string;
  public _external_codigoConsorcio: string;
  public _external_codigoSucursal: string;
  public _external_tipoDocumento: string;

  public CargarServiciosEspeciales: boolean;
  public ocultarCabecera: boolean;

  public mostrarDetalle: boolean;
  public mostrarExcepciones: boolean;

  public query: any;


  public ImagenCargada: boolean;
  public NombreImagen: string;
  public archivos: any;
  public archivo: any;
  public imagen: Imagen = new Imagen();
  public imagenes: Imagen[];


  public verImagen: boolean;

  public buscando: boolean = false;
  public editaDetalle: boolean;
  public processedCount: number;
  public totalFiles: number;

  public descripcion: string;

  public contenedorLinea: string;
  public listaEmpaqueLinea: string;
  public movinvLinea: string;
  public duaLinea: string;
  public facturaLinea: string;
  //public fechaLinea:string;

  constructor(
    private _socioService: SocioService,
    private _bodegaService: BodegaService,
    private _documentoSalidaService: DocumentoSalidaService,
    private _detalleService: DocumentoDetalleSalidaService,
    private _subirImagenesService: SubirImagenesService,
    private _articuloService: ArticuloService,
    private zonaService: ZonaService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.filtro_exc = "";
    this.inventario = new Inventario();
    this.editaDetalle = false;
    this.detalles = [];
    this.descripcion = "";
    this.excepcionesDocumento = [];


    if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }

    if (this.articulo === undefined) {
      this.articulo = new Articulo();
    }

    if (this.detalle === undefined) {
      this.detalle = new DocumentoDetalleSalida();
    }

    this.cargarBodegas();
    this.getZona();

  }

  regresar() {

    this.CargarServiciosEspeciales = false;
    this.mostrarExcepciones = false;
    this.excepcionesDocumento = [];
    this.cargandoImagen = false;
    this.onReturn.emit();
  }


  iniciaBusquedaImagen() {

    this.cargandoImagen = !this.cargandoImagen;
    this.CargarServiciosEspeciales = false;

  }

  toggleCabecera() {

    this.CargarServiciosEspeciales = false;
    if (!this.mostrarDetalle) {
      if (this.cabecera.codigoDocumento === undefined) {
        alert("Debe indicar el número de documento");
        return;
      }

      // if (this.cabecera.codigoBodega === undefined) {
      //   alert("Debe seleccionar el almacén");
      //   return;
      // }

    }

    this.cargandoImagen = false;
    this.mostrarDetalle = !this.mostrarDetalle;
    this.mostrarExcepciones = false;


  }

  filtroToggle() {

  }

  agregarDocumento(_consorcio: Consorcio, _sucursal: Sucursal) {

    this.agregando = true;

    this.cabecera.codigoBodega = null;
    this.consorcio = _consorcio;
    this.sucursal = _sucursal;
    this.cabecera = new DocumentoSalida();
    var date = new Date();
    this.cabecera.codigoDocumento = this.consorcio.documentoPrefijo + "-" + date.getFullYear() + "" + (date.getMonth() + 1) + "" + date.getDate() + "" + date.getHours() + "" + date.getMinutes();

    this.cabecera.bultos = 0;
    this.cabecera.kilos = 0;
    this.cabecera.impuestos = 0;
    this.cabecera.valorCIF = 0;
    this.articulo = new Articulo();
    this.detalle = new DocumentoDetalleSalida();
    this.detalles = [];

    this.cabecera.estado = "PENDIENTE";

    this.cargarClientes(_consorcio);

  }

  editarDocumento(_consorcio: Consorcio, _sucursal: Sucursal, _cabecera: DocumentoSalida) {

    this.agregando = false;

    this.consorcio = _consorcio;
    this.sucursal = _sucursal;

    this.cabecera = _cabecera;
    this.cabecera.fecha = this.datePipe.transform(_cabecera.fecha, 'yyyy-MM-dd');
    this.articulo = new Articulo();
    this.detalle = new DocumentoDetalleSalida();


    this.detalles = [];

    this.cargarClientes(_consorcio);
    this.buscarBodega();

    this.cargarDetalles();


  }

  buscarSocio() {

    for (var i = 0; i <= this.socios.length - 1; i++) {

      if (this.socios[i].codigoSocio === this.cabecera.codigoCliente) {
        this.socio = this.socios[i];
      }
    }

  }

  buscarBodega() {

    for (var i = 0; i <= this.bodegas.length - 1; i++) {

      if (this.bodegas[i].codigoBodega === this.cabecera.codigoBodega) {
        this.bodega = this.bodegas[i];
      }
    }

  }

  cargarDetalles() {

    // var query: any;

    // query = { "codigoConsorcio": this.consorcio.codigoConsorcio, "codigoDocumento": this.cabecera.codigoDocumento };

    this._detalleService.getDetalleByDocumento(this.consorcio.codigoConsorcio, this.cabecera.codigoDocumento)
      .subscribe(
        data => {
          this.detalles = data;

          console.log(data);
        },
        err => {
          console.log(err);
        });
    this.editaDetalle = false;
  }

  cargarClientes(_consorcio: Consorcio) {
    this.query = {
      "codigoConsorcio": _consorcio.codigoConsorcio,
      "tipo": "CLIENTE"
    };

    this._socioService.getSocios(this.query)
      .subscribe(
        data => {
          this.socios = data;
          this.buscarSocio();
        },
        err => {
          console.clear();
          console.log(err._body);
        });
  }


  cargarBodegas() {
    this._bodegaService.getBodegas()
      .subscribe(
        data => this.bodegas = data,
        err => {
          console.log(err);
        });
  }

  seleccionBodega(_bodega: Bodega) {
    this.cabecera.codigoBodega = _bodega.codigoBodega;
  }

  seleccionCliente(_socio: Socio) {
    this.cabecera.codigoCliente = _socio.codigoSocio;
  }

  editarRegistro(detalle: DocumentoDetalleSalida) {
    this.detalle = detalle;

    this.contenedorLinea = detalle.contenedor;
    this.listaEmpaqueLinea = detalle.listaEmpaque;
    this.movinvLinea = detalle.movInv;
    this.duaLinea = detalle.dua;
    this.facturaLinea = detalle.factura;

    this.editaDetalle = true;
    this._articuloBuscar.cargarArticulo(detalle.codigoArticulo);
  }

  cargarInventarioArticulo(articulo: Articulo) {

    this.inventario = new Inventario();

    this._articuloService.getInventarioByArticulo({ "codigoArticulo": articulo.codigoArticulo, "codigoDocumento": this.cabecera.codigoDocumento, "codigoConsorcio": this.consorcio.codigoConsorcio, "codigoSucursal": this.sucursal.codigoSucursal })
      .subscribe(
        data => {

          if (data.length === 0) {

            const dataTemp: Inventario[] = [{ CODIGOARTICULO: articulo.codigoArticulo, APTO: 0, DISPONIBLE: 0, NO_APTO: 0, RESERVADO: 0 }];
            this.inventario = dataTemp[0];
          } else {
            this.inventario = data[0];
          }


        },
        err => {
          console.log(err);
        });

  }

  sumaUnidades() {
    var sumatoria = 0;
    if (this.detalles.length === 0) {
      return sumatoria;
    }
    for (var x = 0; x < this.detalles.length; x++) {
      if (this.detalles[x].cantidad !== null && this.detalles[x].cantidad !== undefined) {
        sumatoria = sumatoria + parseFloat(this.detalles[x].cantidad.toString());
      }
    }
    return sumatoria;
  }

  sumaBultos() {
    var sumatoria = 0;
    if (this.detalles.length === 0) {
      return sumatoria;
    }
    for (var x = 0; x < this.detalles.length; x++) {
      if (this.detalles[x].bultos !== null && this.detalles[x].bultos !== undefined) {
        sumatoria = sumatoria + parseFloat(this.detalles[x].bultos.toString());
      }

    }
    return sumatoria;
  }

  guardar() {

    if (this.cabecera.id === undefined) {
      this.cabecera.id = 0;
    }

    if (this.cabecera.estado === undefined) {
      this.cabecera.estado = "PENDIENTE";
    }

    if (this.cabecera.referencia1 === undefined) {
      this.cabecera.referencia1 = '';
    }

    if (this.cabecera.referencia2 === undefined) {
      this.cabecera.referencia2 = '';
    }

    if (this.cabecera.referenciaERP === undefined) {
      this.cabecera.referenciaERP = '';
    }

    if (this.cabecera.comentarios === undefined) {
      this.cabecera.comentarios = '';
    }


    if (this.cabecera.dua === undefined) {
      this.cabecera.dua = '';
    }


    if (this.cabecera.factura === undefined) {
      this.cabecera.factura = '';
    }


    if (this.cabecera.contenedor === undefined) {
      this.cabecera.contenedor = '';
    }


    if (this.cabecera.movInv === undefined) {
      this.cabecera.movInv = '';
    }

    if (this.cabecera.listaEmpaque === undefined) {
      this.cabecera.listaEmpaque = '';
    }

    if (this.cabecera.ordenOriginal === undefined) {
      this.cabecera.ordenOriginal = '';
    }

    if (isNullOrUndefined(this.cabecera.codigoCliente) || this.cabecera.codigoCliente === '') {
      alert('Seleccione el cliente');
      return;
    }

    if (isNullOrUndefined(this.cabecera.fecha) || this.cabecera.fecha === '') {
      alert('Seleccione la fecha');
      return;
    }

    if (this.detalles.length <= 0) {
      alert('El documento debe de tener detalles');
      return;
    }


    this.cabecera.codigoConsorcio = this.consorcio.codigoConsorcio;
    this.cabecera.codigoSucursal = this.sucursal.codigoSucursal;
    this.cabecera.codigoBodega = this.consorcio.codigoBodega;

    for (const iterator of this.detalles) {
      iterator.fecha = this.cabecera.fecha;
    }

    this.cabecera.documentoDetalleSalidas = this.detalles;



    this._documentoSalidaService.insert(this.cabecera).subscribe(
      result => {
        {
          if (result.tipoResultado === 'ERROR') {
            alert('Ha ocurrido un error, ' + result.mensaje);
          } else {
            this.cargarExcepciones();
            alert('Se ha guardado correctamente');
            this.regresar();
          }
        }
      },
      err => {
        console.log(err);
      });
  }


  articuloSeleccionado($event) {
    this.articulo = $event;
    if (!this.editaDetalle) {
      this.detalle.bultos = 0;
      this.detalle.cantidad = 0;

      if (this.articulo.controlSeries) {
        this.detalle.serie = '';
      }

    }

    this.cargarInventarioArticulo(this.articulo);
  }

  ObtenerPesoCostoDetalle(_detalle: DocumentoDetalleSalida) {

    if (this.consorcio === null) {
      return;
    }

    this.query = { "codigoConsorcio": this.consorcio.codigoConsorcio, "queryText": _detalle.codigoArticulo };

    this._articuloService.getArticuloByCodigo(this.query)
      .subscribe(
        data => {
          _detalle.valorCIF = (((_detalle.cantidad / data[0].unidadesPaquete) + (_detalle.bultos)) * ((this.cabecera.valorCIF + this.cabecera.impuestos) / this.cabecera.bultos));
          _detalle.kilos = (((_detalle.cantidad / data[0].unidadesPaquete) + (_detalle.bultos)) * (this.cabecera.kilos / this.cabecera.bultos))
        },
        err => {
          console.clear();
          console.log(err._body);
        });
  }


  cargarServiciosEspeciales() {

    if (this.ocultarCabecera) {
      this.anularCargaServiciosEspeciales();
      return;
    }
    this.ocultarCabecera = true;
    this._external_codigoDocumento = this.cabecera.codigoDocumento;
    this._external_codigoConsorcio = this.cabecera.codigoConsorcio;
    this._external_codigoSucursal = this.cabecera.codigoSucursal;
    this._external_tipoDocumento = "SALIDA";
    this.CargarServiciosEspeciales = true;
  }

  anularCargaServiciosEspeciales() {
    this.ocultarCabecera = false;
    this.CargarServiciosEspeciales = false;
  }


  guardarDetalle() {

    this.detalle.codigoConsorcio = this.consorcio.codigoConsorcio;
    this.detalle.codigoDocumento = this.cabecera.codigoDocumento;
    this.detalle.codigoArticulo = this.articulo.codigoArticulo;

    if (isNullOrUndefined(this.detalle.idLinea)) {
      this.detalle.idLinea = this.detalles.length;
    } else {
      this.detalle.idLinea = this.detalle.idLinea;
    }


    if (this.articulo.controlSeries) {


      let detalleSerie = this.detalles.filter(f => f.codigoArticulo === this.articulo.codigoArticulo);


      for (let index = 0; index < detalleSerie.length; index++) {
        const element = this.detalles[index];

        // valida si la serie esta repetida
        if (element.serie === this.detalle.serie && this.detalle.serie !== '') {
          alert('La serie está siendo repetida.');
          return;
        } else {



          if (element.serie !== this.detalle.serie && this.detalle.serie === '') {
            alert('El artículo se solícita por serie específica.');
            return;
          } else {

            if (element.serie === '' && this.detalle.serie !== '') {

              alert('El artículo se solícita por serie específica.');
              return;
            }
          }
        }

      }

      // this._detalleService.getDocumentoValidarSerie(this.detalle.codigoConsorcio,
      //   this.detalle.codigoDocumento, this.detalle.codigoArticulo, this.detalle.serie).subscribe(
      //     data => {

      //       if (data.tipoResultado === 'ERROR') {

      //         alert(data.mensaje);
      //         return;
      //       } else {

      //       }
      //     },
      //     error => {
      //       console.log(error);
      //     }
      //   );


      // correcto 
      if (this.detalle.serie !== '') {
        this.detalle.cantidad = 1;
        this.detalle.bultos = 0;
      }

    } else {

      this.detalle.serie = '';
      let total = (this.detalle.cantidad + this.detalle.bultos);

      if (total === 0) {
        alert('Las cantidades deben ser mayor a cero');
        return;
      }

    }

    var agregar: boolean;
    if (this.detalles.length > 0) {
      if ((this.detalle.id === 0) || (this.detalle.id === undefined)) {
        this.detalle.id = Math.max.apply(Math, this.detalles.map(function (o) { return o.id; })) + 1;
        agregar = true;
      }
    } else {
      agregar = true;
      this.detalle.id = 1;
    }


    if (this.duaLinea == undefined) {
      this.duaLinea = "";
    }

    if (this.contenedorLinea == undefined) {
      this.contenedorLinea = "";
    }


    if (this.movinvLinea == undefined) {
      this.movinvLinea = "";
    }


    if (this.listaEmpaqueLinea == undefined) {
      this.listaEmpaqueLinea = "";
    }


    if (this.facturaLinea == undefined) {
      this.facturaLinea = "";
    }



    this.detalle.nombreArticulo = this.articulo.nombreLargo;

    this.detalle.fecha = this.cabecera.fecha;
    this.detalle.dua = this.duaLinea;
    this.detalle.contenedor = this.contenedorLinea;
    this.detalle.movInv = this.movinvLinea;//this.cabecera.movInv;    
    this.detalle.factura = this.facturaLinea;
    this.detalle.listaEmpaque = this.listaEmpaqueLinea;
    this.detalle.valorCIF = this.cabecera.valorCIF;
    this.detalle.impuestos = this.cabecera.impuestos;
    //this.detalle.kilos = this.cabecera.kilos;    

    this.duaLinea = "";
    this.contenedorLinea = "";
    this.movinvLinea = "";
    this.movinvLinea = "";
    this.listaEmpaqueLinea = "";
    this.facturaLinea = "";
    //this.ObtenerPesoCostoDetalle(this.detalle);

    this.detalle.kilos = (((parseInt(this.detalle.cantidad.toString()) / parseInt(this.articulo.unidadesPaquete.toString())) + (parseInt(this.detalle.bultos.toString()))) * (parseFloat(this.cabecera.kilos.toString()) / parseInt(this.cabecera.bultos.toString())));

    this.detalle.valorCIF = (((parseInt(this.detalle.cantidad.toString()) / parseInt(this.articulo.unidadesPaquete.toString())) + (parseInt(this.detalle.bultos.toString()))) * ((parseFloat(this.cabecera.valorCIF.toString()) + parseFloat(this.cabecera.impuestos.toString())) / parseInt(this.cabecera.bultos.toString())));


    if (isNaN(this.detalle.kilos)) {
      this.detalle.kilos = 0;
    }


    if (isNaN(this.detalle.valorCIF)) {
      this.detalle.valorCIF = 0;
    }


    if (this.detalle.lote === undefined) {
      this.detalle.lote = '';
    }

    if (this.detalle.referencia1 === undefined) {
      this.detalle.referencia1 = '';
    }

    if (this.detalle.referencia2 === undefined) {
      this.detalle.referencia2 = '';
    }

    if (this.detalle.comentarios === undefined) {
      this.detalle.comentarios = '';
    }



    if (this.detalle.serie !== '') {


      this._detalleService.getDocumentoValidarSerie(this.detalle.codigoConsorcio,
        this.detalle.codigoDocumento, this.detalle.codigoArticulo, this.detalle.serie).subscribe(
          data => {

            if (data.tipoResultado === 'ERROR') {

              alert(data.mensaje);
              return;
            } else {

              if (agregar) {
                let unidades = (this.detalle.cantidad) + (this.detalle.bultos * this.articulo.unidadesPaquete);
                if (unidades > parseInt(this.inventario.DISPONIBLE.toString())) {
                  if (unidades > (parseInt(this.inventario.DISPONIBLE.toString()) + parseInt(this.inventario.NO_APTO.toString()))) {
                    alert("Inventarios insuficiente, por favor verifique la existencia de inventario.");
                  } else {
                    if (confirm("Esta tomando inventario no apto, ¿está seguro que desea despachar inventario no apto?")) {
                      this.detalles.push(this.detalle);
                    }
                  }
                } else {
                  this.detalles.push(this.detalle);

                  this.detalle = new DocumentoDetalleSalida();
                  this._articuloBuscar.limpiarDatos();
                  this.articulo = new Articulo();
                  this.editaDetalle = false;
                }

              }

            }
          },
          error => {
            console.log(error);
          }
        );

    } else {

      if (agregar) {
        let unidades = (this.detalle.cantidad) + (this.detalle.bultos * this.articulo.unidadesPaquete);
        if (unidades > parseInt(this.inventario.DISPONIBLE.toString())) {
          if (unidades > (parseInt(this.inventario.DISPONIBLE.toString()) + parseInt(this.inventario.NO_APTO.toString()))) {
            alert("Inventarios insuficiente, por favor verifique la existencia de inventario.");
          } else {
            if (confirm("Esta tomando inventario no apto, ¿está seguro que desea despachar inventario no apto?")) {
              this.detalles.push(this.detalle);
            }
          }
        } else {
          this.detalles.push(this.detalle);

          this.detalle = new DocumentoDetalleSalida();
          this._articuloBuscar.limpiarDatos();
          this.articulo = new Articulo();
          this.editaDetalle = false;
        }

      }
    }

  }

  guardarDetalles() {
    for (var i = 0; i <= this.detalles.length - 1; i++) {
      this._detalleService.insert(this.detalles[i]).subscribe(
        result => {
          console.log(result);
        },
        err => {
          console.log(err);
        });
    }
    this.regresar();
  }

  toggleExcepciones() {

    this.mostrarExcepciones = !this.mostrarExcepciones;
    this.cargandoImagen = false;

    this.excepcionesDocumento = [];

    if (this.mostrarExcepciones) {
      this.cargarExcepciones();
    }

  }

  eliminarDocumento() {

    if (confirm("¿Realmente desea eliminar el documento: " + this.cabecera.codigoDocumento + " ?")) {

      this._detalleService.deleteAll(this.cabecera).subscribe(
        data => {
          if (data.Resultado === true) {
            alert("Documento eliminado...");
            this.regresar();
          } else {
            alert("Error al eliminar documento");
          }
        },
        err => {
          alert("Error al eliminar documento");
          console.log(err._body);
        });
    }

  }

  cargarExcepciones() {

    this.query = { "codigoDocumento": this.cabecera.codigoDocumento, "codigoConsorcio": this.consorcio.codigoConsorcio };

    this._detalleService.getDetalleExcepciones(this.query).subscribe(
      data => {
        this.excepcionesDocumento = data;
      },
      err => {
        console.log(err);
      });

  }

  aprobarDocumento() {

    if (confirm("Desea aprobar el documento: " + this.cabecera.codigoDocumento)) {

      //this.query = { "codigoDocumento": this.cabecera.codigoDocumento, "codigoConsorcio": this.consorcio.codigoConsorcio, "estado": "APROBADO" };

      console.log(this.query);

      this._documentoSalidaService.aprobar(this.cabecera.codigoBodega,
        this.cabecera.codigoConsorcio, this.cabecera.codigoSucursal, this.cabecera.codigoDocumento).subscribe(
          result => {
            console.clear();
            console.log("========= APROBACION DE DOCUMENTOS ===============");
            console.log(result);

            if (result.tipoResultado === 'OK') {
              this.regresar();
            } else {
              alert('Ha ocurrido un error, ' + result.mensaje);
            }


          },
          err => {
            console.log(err);
            // alert(err);
            // alert(err._body);
          });
    }
  }


  /*
    Cargar archivo  
  */


  onChangeFile(event) {
    this.ImagenCargada = true;
    var files = event.target.files || event.srcElement.files;
    this.NombreImagen = files.length;
    this.archivos = files;

    this.processedCount = 0;
    this.totalFiles = 0;
  }

  buscarImagen() {
    if (this.cabecera.id === null || this.cabecera.id === undefined || this.cabecera.id === 0) {
      return;
    }
    document.getElementById("Button_File_Image").click();
  }

  cargarArchivo() {
    try {

      this.imagenes = [];
      this.buscando = true;
      this.totalFiles = this.archivos.files;
      this.processedCount = 0;
      this.convertirImagen(0);

    } catch (e) {
      console.log(e);
    }
  }


  convertirImagen(index) {

    this.totalFiles = (this.archivos.length - 1);

    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {

      this.imagen.base64 = myReader.result;
      this.imagen.descripcion = this.descripcion === "" || this.descripcion === null ? "Sin Descripción" : this.descripcion;
      this.imagen.codigoDocumento = this.cabecera.codigoDocumento;
      this.imagen.tipoDocumento = "SALIDA";

      this.imagenes.push(this.imagen);

      this.imagen = new Imagen();

      if (this.totalFiles === this.processedCount) {
        this._subirImagenesService.upload(this.imagenes).subscribe(
          result => {
            alert("Imágenes Guardadas");
            this.buscando = false;
            this.imagen = new Imagen();
            this.imagenes = [];
            this.cargandoImagen = false;
            this.archivo = null;
          },
          err => {
            console.log(err._body);
          });

      } else {
        this.processedCount++;
        this.convertirImagen(this.processedCount);
      }

    }

    myReader.readAsDataURL(this.archivos[index]);

  }


  verGaleria() {

    this.CargarServiciosEspeciales = false;
    console.clear();
    console.log(this.cabecera.codigoDocumento);
    this._galeria.cargarImagenesDocumento(this.cabecera.codigoDocumento, 'SALIDA');
    this.verImagen = true;
  }

  verDocumento() {
    this.verImagen = false;
  }


  eliminarLinea(id: number) {
    if (confirm("¿Desea borrar la linea?")) {

      let index = -1;

      for (var i = 0; i < this.detalles.length; i++) {

        if (this.detalles[i].id === id) {
          index = i;
          break;
        }

      }


      this._detalleService.delete(this.detalle)
        .subscribe(
          data => {
            console.log(data);
            this.detalles = this.detalles.splice(index);
            if (this.detalles.length > 0) {
              this.cargarDetalles();
            }
            alert("Linea eliminada con éxito");
            this.editaDetalle = false;

          },
          err => {
            console.log(err);
          });
    }
  }

  exportarExcepciones() {

    var arr = this.excepcionesDocumento;
    for (var x = 0; x < arr.length; x++) {
      delete arr[x]['ID'];
    }

    var ar = arr;

    //comprobamos compatibilidad
    if (window.Blob && (window.URL)) {
      var contenido = "", d = new Date(), blob, _reader, save, clicEvent;
      //creamos contenido del archivo
      for (var i = 0; i < ar.length; i++) {

        //construimos cabecera del csv
        if (i == 0)
          contenido += Object.keys(ar[i]).join(";") + "\n";
        //resto del contenido
        contenido += Object.keys(ar[i]).map(function (key) {
          return ar[i][key];
        }).join(";") + "\n";

      }
      //creamos el blob
      blob = new Blob(["\ufeff", contenido], { type: 'text/csv' });
      //creamos el reader
      _reader = new FileReader();
      _reader.onload = function (event) {
        //escuchamos su evento load y creamos un enlace en dom
        save = document.createElement('a');
        save.href = event.target.result;
        save.target = '_blank';
        //aquí le damos nombre al archivo
        save.download = "ReporteExcepciones" + d.getDate() + "_" + (d.getMonth() + 1) + "_" + d.getFullYear() + ".csv";
        try {
          //creamos un evento click
          clicEvent = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': true
          });
        } catch (e) {
          //si llega aquí es que probablemente implemente la forma antigua de crear un enlace
          clicEvent = document.createEvent("MouseEvent");
          clicEvent.initEvent('click', true, true);
        }
        //disparamos el evento
        save.dispatchEvent(clicEvent);
        //liberamos el objeto window.URL
        (window.URL).revokeObjectURL(save.href);
      }
      //leemos como url
      _reader.readAsDataURL(blob);
    } else {
      //el navegador no admite esta opción
      alert("Su navegador no permite esta acción");
    }
  }

  imprimir() {
    let contenido, ventana;
    contenido = document.getElementById('print-section').innerHTML;
    ventana = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    ventana.document.open();
    ventana.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <link rel="stylesheet" href="reporte-inventario.component.css" type="text/css" media="print"/>
          <style>
          //........Customized style.......
          </style>
        </head>
    <body onload="window.print();window.close()">${contenido}</body>
      </html>`
    );
    ventana.document.close();
  }


  actualizarRecomedacion(excepcion: Excepcion) {
    if (parseInt(excepcion.UD_RECOMENDADO) === 0) {
      alert("No se puede aprobar cantidades iguales a 0...");
      return;
    }
    if (confirm("¿Desea aplicar la recomendación?")) {

      this.query = [{ "id": excepcion.ID, "cantidad": excepcion.UD_RECOMENDADO }];


      this._detalleService.actualizaRecomendacion(this.query)
        .subscribe(
          data => {
            this.cargarDetalles();
            this.cargarExcepciones();
            this.mostrarDetalle = true;
            this.mostrarExcepciones = false;
            alert("Linea actualizada con éxito");
          },
          err => {
            alert("Ha ocurrido un error intente de nuevo");
            console.log(err);
          });
    } else {
      return;
    }


  }

  actualizarRecomedaciones(excepciones: Excepcion[]) {

    this.query = [];
    var arr = excepciones;

    if (confirm("¿Desea aplicar todas las recomendaciones?")) {
      for (var x = 0; x < arr.length; x++) {
        if (parseInt(arr[x].UD_RECOMENDADO) !== 0) {
          this.query.push({ "id": arr[x].ID, "cantidad": arr[x].UD_RECOMENDADO });
        }
      }

      this._detalleService.actualizaRecomendacion(this.query)
        .subscribe(
          data => {
            this.cargarDetalles();
            this.cargarExcepciones();
            this.mostrarDetalle = true;
            this.mostrarExcepciones = false;
            alert("Lineas actualizadas con éxito");
          },
          err => {
            alert("Ha ocurrido un error intente de nuevo");
            console.log(err);
          });
    } else {
      return;
    }



  }

  getZona() {

    this.zonaService.getZonas().subscribe(
      data => {
        this.zonas = data;
      },
      error => {
        console.log(error);
      }
    );

  }


  /**
   * Limpia el detalle 
   */
  LimpiarDetalle() {

    this.articulo = new Articulo();
    this.inventario = new Inventario();
    this.detalle = new DocumentoDetalleSalida();
    this._articuloBuscar.limpiarDatos();

    this.duaLinea = "";
    this.contenedorLinea = "";
    this.movinvLinea = "";
    this.listaEmpaqueLinea = "";
    this.facturaLinea = "";

  }

  documentoValidarSerie() {
    this._detalleService.getDocumentoValidarSerie(this.detalle.codigoConsorcio,
      this.detalle.codigoDocumento, this.detalle.codigoArticulo, this.detalle.serie).subscribe(
        data => {

          if (data.tipoResultado === 'ERROR') {

            alert(data.mensaje);
            return;

          }
        },
        error => {
          console.log(error);
        }
      );
  }

}





// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/documento-salida-mantenimiento/documento-salida-mantenimiento.component.ts